/**
 * Application Logger Utility
 * Environment-aware logging that only outputs in development
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log('[App]', ...args);
  },

  error: (message: any, error: any = null) => {
    if (isDev) {
      console.error('[Error]', message, error);
    } else {
      console.error('[Error]', message);
    }
  },

  warn: (...args: any[]) => {
    if (isDev) console.warn('[Warn]', ...args);
  },

  debug: (...args: any[]) => {
    if (isDev) console.debug('[Debug]', ...args);
  },

  info: (...args: any[]) => {
    if (isDev) console.info('[Info]', ...args);
  },

  // For API errors - sanitizes sensitive data
  apiError: (endpoint: string, error: any) => {
    const message = `API Error: ${endpoint}`;
    if (isDev) {
      console.error(message, error?.response?.data || error?.message || error);
    } else {
      console.error(message, error?.message || 'Request failed');
    }
  },
};

export default logger;
